module.exports = __webpack_public_path__ + "static/media/C1.b418e670.jpg";